<div *ngIf="reportSearch" class="rounded-tl-lg rounded-tr-lg">

  <section *ngIf="(personExpanded && companyExpanded) || isMobile" class="flex justify-between items-center p-2 px-6 pt-3 pb-3">
    <div>
      <div class="flex justify-start items-center">
        <span class="font-poppins font-light text-sm text-secondary dark:text-primary-200 mr-1">{{ 'last_updated' | translate }}:</span>
        <span class="font-poppins text-sm text-secondary-900 font-semibold dark:text-primary-200">{{reportSearch.updated_at ? formatDate(reportSearch.updated_at) : ''}}</span>
        <button type="button" class="secondary-button hidden text-secondary-900 dark:text-primary-200">Update</button>

        <div *ngIf="reportSearch.search_status_id !== 3" class="ml-3" matTooltip="Gathering data" matTooltipPosition="right" matTooltipClass="violet-500-tooltip">
          <app-pulse-loading [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
        </div>

        <div *ngIf="reportSearch.search_status_id === 3" class="ml-3" matTooltip="Report completed" matTooltipPosition="right" matTooltipClass="violet-500-tooltip">
          <span [ngClass]="['relative', 'flex', 'items-center', 'size-2']">
            <span [ngClass]="['relative', 'inline-flex', 'rounded-full', 'size-2', 'bg-violet-500']"></span>
          </span>
        </div>

        <!-- Regenerate insights (1 credit) -->
        <button *ngIf="reportSearch.search_status_id === 3" type="button"
                (click)="regenerateClicked.emit()"
                class="ml-3 inline-flex items-center gap-1 rounded-md bg-violet-100 px-2.5 py-1 text-xs font-medium text-violet-600 transition hover:bg-violet-200 dark:text-primary-200 dark:hover:bg-violet-500/10">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-3.5 w-3.5">
            <path fill-rule="evenodd" d="M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h1.633a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v3.181a.75.75 0 0 0 1.5 0v-1.406l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V3.989a.75.75 0 0 0-1.5 0v1.407l-.31-.31A7 7 0 0 0 3.239 8.224a.75.75 0 1 0 1.449.39 5.5 5.5 0 0 1 9.201-2.466l.312.311H12.57a.75.75 0 0 0 0 1.5h3.176a.75.75 0 0 0 .53-.219Z" clip-rule="evenodd" />
          </svg>
          {{ 'report.regenerate.button' | translate }}
        </button>

        <!--
        <span class="font-poppins text-sm text-[#a0a7e4] dark:text-primary-200 px-3">|</span>

        Open Tags
        <button type="button" class="group flex items-center font-medium text-gray-700" aria-controls="disclosure-1" aria-expanded="false" (click)="toggleTags()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-2 h-5 w-5 flex-none text-gray-400 group-hover:text-gray-500">
            <path fill-rule="evenodd" d="M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" clip-rule="evenodd" />
          </svg>
          <div class="flex items-center">
            <span class="font-poppins font-semibold text-sm text-secondary-900 dark:text-primary-200">Tags</span>
          </div>
        </button>

        Selected Tags
        <div *ngIf="selectedFilters.length > 0" class="hidden lg:block pl-3">
          <div class="-m-1 flex flex-wrap items-center">
            <span *ngFor="let filter of selectedFilters" class="m-1 inline-flex items-center rounded-full border border-gray-200 bg-white py-1 pl-3 pr-2 text-sm font-medium text-gray-900">
              <span>{{ filter.label }}</span>
              <button type="button" class="ml-1 inline-flex h-4 w-4 flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500" (click)="removeFilter(filter.category, filter.value)">
                <span class="sr-only">Remove filter for {{ filter.label }}</span>
                <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                  <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                </svg>
              </button>
            </span>
          </div>
        </div>
        -->

      </div>
    </div>


    <div class="flex items-center space-x-3">

      <!-- Collecting Data -->
      <!--
      <button class="flex items-center space-x-2 px-4 h-[38px] bg-transparent border border-transparent text-sm font-semibold rounded-lg hover:bg-opacity-90 focus:outline-none w-max"
              [matTooltip]="isLoading ? 'We are currently gathering data for this report.' : null"
              matTooltipPosition="below"
              matTooltipClass="'custom-tooltip'"
              (click)="onReportLoader()"
      >
        <app-pulse-loading [status]="isLoading ? 'loading' : 'completed'" class="flex justify-center items-center"></app-pulse-loading>
      </button>
      -->

      <!-- Workspace -->
      <a *ngIf="reportSearch.workspace?.id && !reportSearch.workspace.is_default"
         [routerLink]="['/workspaces', reportSearch.workspace.id]"
         class="flex justify-center items-center h-9 w-9 flex-shrink-0 rounded-lg bg-violet-500 shadow shadow-violet-200 cursor-pointer"
         [matTooltip]="reportSearch.workspace.name || 'Workspace'"
         matTooltipPosition="above"
         matTooltipClass="violet-500-tooltip">
        <span class="text-white text-sm font-semibold">{{ workspaceAcronym(reportSearch.workspace.name) }}</span>
      </a>

      <button type="button" class="flex justify-center items-center secondary-button rounded-lg bg-violet-100 dark:bg-secondary border-none hover:opacity-90 tracking-wide" (click)="onShare()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 text-violet-600 dark:text-primary-200 pr-1">
          <path d="M13 4.5a2.5 2.5 0 1 1 .702 1.737L6.97 9.604a2.518 2.518 0 0 1 0 .792l6.733 3.367a2.5 2.5 0 1 1-.671 1.341l-6.733-3.367a2.5 2.5 0 1 1 0-3.475l6.733-3.366A2.52 2.52 0 0 1 13 4.5Z" />
        </svg>

        <span class="font-normal text-violet-600 dark:text-primary-200">Share</span>
      </button>

      <button *ngIf="user.linkedin_url === this.reportSearch.linkedin_profile && user.linkedin_url" type="button" class="hidden lg:block justify-center items-center secondary-button rounded-lg bg-violet-100 dark:bg-secondary border-none hover:opacity-90 tracking-wide" [routerLink]="[ '/' + this.user.public_profile_url]">
        <span class="font-normal text-violet-600 dark:text-primary-200">Public Profile</span>
      </button>

      <a href="https://salesommo.com/procesio" target="_blank" type="button" class="hidden lg:block whitespace-nowrap secondary-button text-secondary bg-gradient-to-r from-violet-100 to-violet-100/50 !border-none dark:text-primary-200 dark:from-secondary dark:to-secondary hover:opacity-90 tracking-wide">
        <span class="font-normal text-transparent bg-clip-text bg-gradient-to-br from-violet-600 to-violet-600/50 dark:from-primary-200 dark:to-primary-200">Transcribe and summarize</span>
      </a>
    </div>
  </section>

  <section class="px-6">

    <!--
    <div [ngClass]="{'hidden': !personExpanded && !companyExpanded && !isMobile}">
      <app-report-tags [reportId]="reportSearch.id" [reportTags]="reportSearch.tagsData" [(tagsOpen)]="tagsOpen" (selectedFiltersChange)="updateSelectedFilters($event)" (heightChange)="updateTagsHeight($event)"></app-report-tags>
    </div>
    -->

    <div class="bg-white dark:bg-[#252c5f] grid grid-cols-2 p-3 sm:p-3 sm:dark:border-[#3c4377] rounded-xl relative z-20" [ngClass]="(personExpanded && companyExpanded) ? '' : 'rounded-b-none border-b border-violet-50 md:mt-6'">

      <div  class="col-span-2 xl:col-span-1 mx-auto lg:mx-0 lg:max-w-none max-w-2xl items-start w-full" >

        <div class="bg-white dark:bg-[#252c5f] rounded-md p-3">

          <button (click)="expandPerson()" *ngIf="!personExpanded" class="flex justify-between w-full">

            <!-- Person -->
            <div class="flex items-center">
              <div class="flex-shrink-0">
                <img class="h-12 w-12 rounded-full" [src]="report.person_avatar"
                     (error)="onImageError($event)"
                     alt="">
              </div>
              <div class="ml-4">
                <div class="flex items-center">
                  <h3 class="text-base font-semibold leading-6 text-secondary-900 dark:text-white mr-2">{{ report.person_full_name }}</h3>
                  <div class="hidden">
                    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-[#4dae51] px-1.5 py-0.5 text-xs font-medium text-white">100&#125;</span>
                  </div>
                </div>

                <div class="flex">
                  <p class="hidden lg:block text-sm text-[#3c4377] dark:text-primary-200">{{ report.person_city ? report.person_city + ',' : '' }} {{ report.person_state ? report.person_state + ',' : '' }} {{ report.person_country }}</p>
                  <p class="block lg:hidden text-sm text-[#3c4377] dark:text-primary-200">{{ report.person_city ? report.person_city : '' }}</p>
                </div>

              </div>
            </div>

            <!-- Blue -->
            <button class="blue-card rounded-md p-3">
              <svg viewBox="0 0 15 20" class="w-6 h-6" fill="none">
                <path d="M6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8H8.5C9.05228 8 9.5 7.55228 9.5 7C9.5 6.44772 9.05228 6 8.5 6H6.5Z" fill="#1B9ED1"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 16V13.3264C12.8649 12.2029 14.5 9.7924 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 9.7924 2.13505 12.2029 4.5 13.3264V16C4.5 16.5523 4.94772 17 5.5 17H9.5C10.0523 17 10.5 16.5523 10.5 16ZM9.64182 11.5198L8.63107 12H6.36893L5.35818 11.5198C3.66429 10.7152 2.5 8.99156 2.5 7C2.5 4.23858 4.73858 2 7.5 2C10.2614 2 12.5 4.23858 12.5 7C12.5 8.99156 11.3357 10.7152 9.64182 11.5198ZM6.5 15V14H8.5V15H6.5Z" fill="#1B9ED1"/>
                <path d="M7.5 20C8.60457 20 9.5 19.1046 9.5 18H5.5C5.5 19.1046 6.39543 20 7.5 20Z" fill="#1B9ED1"/>
              </svg>
            </button>

          </button>

          <!-- Person Expanded -->
          <app-person-expanded  [hidden]="!personExpanded"
                                [reportSearch]="reportSearch"
                                [report]="report"
                                [company]="company"
                                (dataEmitter)="expandPerson()"
                                (editPromptToggled)="onEditPromptToggled($event)">
          </app-person-expanded>

        </div>

      </div>

      <div class="col-span-2 xl:col-span-1 mx-auto lg:mx-0 lg:max-w-none flex max-w-2xl items-start justify-between w-full" >

        <div class="w-full rounded-lg p-3" [ngClass]="{'bg-violet-50/50 dark:bg-secondary-800': !companyExpanded}">

          <button (click)="expandCompany()" *ngIf="!companyExpanded"  class="flex justify-between w-full">

            <div *ngIf="company" class="flex items-center">
              <div class="flex-shrink-0">
                <img *ngIf="company?.logo_url" class="h-12 w-12 rounded-md shadow-md" [src]="company?.logo_url" (error)="onImageError($event)" alt="logo">
              </div>
              <div class="ml-4">
                <div class="flex items-center">

                  <!-- Organization Name with Conditional Truncation on Mobile -->
                  <h3 class="text-base font-semibold leading-6 text-secondary-900 dark:text-white truncate-on-mobile" [attr.title]="company?.name">
                    {{ company?.name | slice:0:20 }}{{ company?.name?.length > 20 ? '...' : '' }}
                  </h3>

                  <!-- ICP Score -->
                  <span [ngClass]="{'bg-icp-low': icpScore <= 35, 'bg-icp-medium': icpScore > 35 && icpScore <= 65, 'bg-icp-high': icpScore > 65}"
                        class="text-sm font-semibold text-white rounded-md py-0.5 px-3 ml-2">
                              {{ icpScore !== null ? icpScore : 'N/A' }}
                  </span>

                </div>
                <div class="flex">
                  <p class="hidden lg:block text-sm text-[#3c4377] dark:text-primary-200">{{ company?.city ? company?.city + ',' : '' }} {{ company?.state ? company?.state + ',' : '' }} {{ company?.country }}</p>
                  <p class="block lg:hidden text-sm text-[#3c4377] dark:text-primary-200">{{ company?.city ? company?.city : '' }}</p>
                </div>

              </div>
            </div>

            <!-- Blue -->
            <div *ngIf="reportSearch.search_person.enhanced_data?.organization" class="blue-card rounded-md p-3">
              <svg viewBox="0 0 15 20" class="w-6 h-6" fill="none">
                <path d="M6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8H8.5C9.05228 8 9.5 7.55228 9.5 7C9.5 6.44772 9.05228 6 8.5 6H6.5Z" fill="#1B9ED1"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 16V13.3264C12.8649 12.2029 14.5 9.7924 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 9.7924 2.13505 12.2029 4.5 13.3264V16C4.5 16.5523 4.94772 17 5.5 17H9.5C10.0523 17 10.5 16.5523 10.5 16ZM9.64182 11.5198L8.63107 12H6.36893L5.35818 11.5198C3.66429 10.7152 2.5 8.99156 2.5 7C2.5 4.23858 4.73858 2 7.5 2C10.2614 2 12.5 4.23858 12.5 7C12.5 8.99156 11.3357 10.7152 9.64182 11.5198ZM6.5 15V14H8.5V15H6.5Z" fill="#1B9ED1"/>
                <path d="M7.5 20C8.60457 20 9.5 19.1046 9.5 18H5.5C5.5 19.1046 6.39543 20 7.5 20Z" fill="#1B9ED1"/>
              </svg>
            </div>

            <div *ngIf="!reportSearch.search_person.enhanced_data?.organization" class="p-6 w-full">
              <p class="text-sm text-gray-500">Company information was not found.</p>
            </div>

          </button>

          <!-- Company Expanded -->
          <app-company-expanded [hidden]="!companyExpanded"
                                [reportSearch]="reportSearch"
                                [report]="report"
                                [company]="company"
                                (dataEmitter)="expandCompany()"
                                (editPromptToggled)="onEditPromptToggled($event)"
                                (icpScoreClicked)="icpScoreClicked.emit()"
                                (companyDetailsModalRequested)="companyDetailsModalRequested.emit($event)"
                                (editRevenueModalRequested)="editRevenueModalRequested.emit($event)">
          </app-company-expanded>

        </div>

      </div>

    </div>

    <!-- Tabs -->
    <div *ngIf="!personExpanded && !companyExpanded"  class="bg-white  dark:bg-[#252c5f] shadow-lg rounded-b-xl px-3 sm:px-6 pb-3 sm:pb-0 relative z-10" [@fadeInOut]="state">
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select (change)="scrollTo($event)" id="tabs" name="tabs" class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-gray-300 focus:outline-none focus:ring-transparent sm:text-sm">
          <option value="personInsights">Person Insights</option>
          <option value="companyInsights">Company Insights</option>
          <option value="industryInsights">Industry Insights</option>
        </select>
      </div>
      <div class="hidden sm:block">
        <div class="">
          <nav class="-mb-px flex space-x-8 tabs" aria-label="Tabs">
            <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
            <button #tabs (click)="scrollToAnchor(i)" *ngFor="let tab of tabs; index as i;" [ngClass]="tab.current ? 'border-[#2957e3] dark:border-primary-200 text-[#2957e3] dark:text-primary-200' : 'border-transparent text-[#3c4377] dark:text-primary-200'" class="whitespace-nowrap border-b-2 py-4 px-1 text-sm font-[500] hover:text-[#2957e3] hover:border-[#2957e3] dark:hover:border-primary-200">{{ tab.name }}</button>
          </nav>
        </div>
      </div>
    </div>
    <!-- / Tabs -->

  </section>

</div>
